import { render, staticRenderFns } from "./EAcoesAuxiliares2026.vue?vue&type=template&id=10187222"
import script from "./EAcoesAuxiliares2026.vue?vue&type=script&lang=js"
export * from "./EAcoesAuxiliares2026.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports